(() => {
  const SLIDE_HEIGHT = 30;

  const normalizeSlideContent = (root) => {
    root.querySelectorAll('.announcement-bar__item p').forEach((p) => {
      p.style.margin = '0';
      p.style.padding = '0';
      p.style.lineHeight = '1.2';
      p.style.display = 'inline';
    });
  };

  const initAnnouncementBar = () => {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar || bar.dataset.announcementReady === 'true') return;
    bar.dataset.announcementReady = 'true';

    const splideElement = bar.querySelector('.splide');
    if (!splideElement) return;

    const slides = splideElement.querySelectorAll('.splide__slide');
    if (slides.length <= 1) return;

    normalizeSlideContent(bar);

    const autoplaySpeed = parseInt(bar.getAttribute('data-autoplay-speed'), 10) || 5000;

    const mount = () => {
      if (typeof window.Splide === 'undefined') return false;

      const splide = new window.Splide(splideElement, {
        type: 'loop',
        direction: 'ttb',
        height: `${SLIDE_HEIGHT}px`,
        fixedHeight: `${SLIDE_HEIGHT}px`,
        autoHeight: false,
        autoplay: true,
        interval: autoplaySpeed,
        speed: 800,
        arrows: false,
        pagination: false,
        drag: false,
        perPage: 1,
        perMove: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        updateOnMove: true,
      });

      splide.on('mounted', () => {
        normalizeSlideContent(bar);
        // Pastikan tiap slide tinggi sama setelah clone loop
        bar.querySelectorAll('.splide__slide').forEach((slide) => {
          slide.style.height = `${SLIDE_HEIGHT}px`;
        });
      });

      splide.mount();
      return true;
    };

    if (mount()) return;

    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (mount() || tries > 40) window.clearInterval(timer);
    }, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBar);
  } else {
    initAnnouncementBar();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section?.querySelector?.('[data-announcement-bar]')) return;
    const bar = section.querySelector('[data-announcement-bar]');
    if (bar) delete bar.dataset.announcementReady;
    initAnnouncementBar();
  });
})();
